import * as React from 'react';

import './style.scss';

const CommentLoader = () => {
  return(
    <div className='lds-spinner'>
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  );
};

export default CommentLoader;
